import type { Plugin, PluginContext } from '@core/bus/types'

/**
 * Реестр плагинов Ядра.
 *
 * Ядро НЕ импортирует конкретные плагины — они регистрируются снаружи
 * (в bootstrap). Это сохраняет однонаправленную изоляцию и позволяет
 * собирать разные наборы плагинов по стране (RU / UZ / KZ ...).
 */
export class PluginRegistry {
  private readonly plugins = new Map<string, Plugin>()
  private initialized = false

  /** Зарегистрировать плагин. Повторный id перезапишет предыдущий с предупреждением. */
  register(plugin: Plugin): this {
    if (this.plugins.has(plugin.id)) {
      console.warn(`[registry] plugin "${plugin.id}" уже зарегистрирован — перезапись`)
    }
    this.plugins.set(plugin.id, plugin)
    return this
  }

  /** Инициализировать все плагины (последовательно, чтобы порядок был предсказуем). */
  async initAll(ctx: PluginContext): Promise<void> {
    if (this.initialized) {
      console.warn('[registry] initAll вызван повторно — пропуск')
      return
    }
    for (const plugin of this.plugins.values()) {
      await plugin.init(ctx)
    }
    this.initialized = true
  }

  /** Корректно завершить работу всех плагинов. */
  async dispose(): Promise<void> {
    for (const plugin of this.plugins.values()) {
      await plugin.dispose?.()
    }
    this.initialized = false
  }

  /** Список id активных плагинов (для статус-индикаторов). */
  list(): string[] {
    return [...this.plugins.keys()]
  }

  /** Количество зарегистрированных плагинов. */
  get size(): number {
    return this.plugins.size
  }
}
